import {observer} from 'mobx-react';
import React from 'react';
import {pagedListResponseUtils} from '../../../domain';
import {Link, PageHeading, PromiseMessage} from '../../../lib/components';
import {ReactNodeGenerator} from '../../../lib/helpers';
import {routes} from '../../../pages/Routes';
import {TeacherStudentsSceneStore} from './TeacherStudentsSceneStore';

function* renderer(store: TeacherStudentsSceneStore): ReactNodeGenerator {
    
    const resultState = store.resultState;
    const isResultPending = resultState?.isPending === true;   
  
    yield (<PromiseMessage key="search-result-status"
                           label="Loading result" state={resultState} align="right"/>);
  
    if (resultState?.isResolved !== true)
      return;
  
    const response = resultState.value;   
  
    if (response === null || response.length === 0) {
      yield (
        <div className="row" key="no-results">
          <div className="col text-center">
            <div className="alert alert-info">
              No records
            </div>
          </div>
        </div>);
      return;
    }
    const rows = response;
  
    yield (
      <div className="row" key="results-table">
        <div className="col">
          <table className="table table-sm table-bordered table-striped table-hover">
            <thead>
            <tr>
              <th><b>Last name</b></th>
              <th><b>First name</b></th>
              <th><b>TimeZone</b></th>
              <th><b>Level</b></th>
            </tr>
            </thead>
            <tbody>
            {
              rows.map((user, index) => (
                <tr key={index}>
                  <td>{user.LastName}</td>
                  <td>{user.FirstName}</td>
                  <td>{user.TimeZone?.UtcName}</td>
                  <td>{user.Student?.Level?.Name}</td>
                </tr>
              ))
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

@observer
export class TeacherStudentsScene extends React.Component {
  store: TeacherStudentsSceneStore;

  constructor(props: any) {
    super(props);
    this.store = new TeacherStudentsSceneStore();
  }

  render() {
    return Array.from(renderer(this.store));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
